module.exports = __webpack_public_path__ + "img/uutechnic.ffe40306.png";